import { ReactComponent as GithubIcon } from 'assets/icons/company/github.svg';
import { ReactComponent as GoogleIcon } from 'assets/icons/company/google.svg';
import { ReactComponent as GrafanaIcon } from 'assets/icons/company/grafana.svg';
import { ReactComponent as WebhookIcon } from 'assets/icons/company/webhook.svg';

export const company = {
  github: GithubIcon,
  google: GoogleIcon,
  grafana: GrafanaIcon,
  webhook: WebhookIcon,
};
